import React from 'react';
import { createPortal } from 'react-dom';
import { Fab, Zoom, useMediaQuery, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

/**
 * Floating create action for mobile list/table pages.
 * Portaled to document.body so position:fixed stays viewport-locked
 * (ancestors with transform, e.g. page enter animation, would otherwise trap it).
 */
const MobileCreateFab = ({ label, onClick, color = 'primary' }) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	return createPortal(
		<Zoom in={isMobile} unmountOnExit>
			<Fab
				color={color}
				variant="extended"
				onClick={onClick}
				aria-label={label}
				sx={{
					position: 'fixed',
					right: 16,
					bottom: 16,
					zIndex: (t) => t.zIndex.fab,
					textTransform: 'none',
					fontWeight: 600,
					px: 2.25,
					boxShadow: 6,
				}}
			>
				<AddIcon sx={{ mr: 1 }} />
				{label}
			</Fab>
		</Zoom>,
		document.body,
	);
};

export default MobileCreateFab;
